import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {Chart} from "chart.js/auto";
import {RevenueTimelineStore} from "../../../store/charts/revenue-timeline-store";
import {Subscription} from "rxjs";
import {SalesDto} from "../../../models/sales/sales-dto";
import {TabOptionModel} from "../../../../../x-components/tab-selection/models/tab-option-model";
import {TimeInterval} from "../../../../common/enums/time/time-interval";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {TabSelectionComponent} from "../../../../../x-components/tab-selection/tab-selection.component";
import {CommonModule} from "@angular/common";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'analytics-revenue-timeline-chart',
  templateUrl: './revenue-timeline-chart.component.html',
  styleUrls: ['./revenue-timeline-chart.component.css'],
  imports: [
    CommonModule,
    TabSelectionComponent,
    ErrorMessageComponent,
    FormsModule
  ],
  providers: [RevenueTimelineStore]
})
export class RevenueTimelineChartComponent implements OnDestroy {
  //isBarChartDataAvailable: boolean = false;
  barChart: Chart | undefined;
  timeIntervalOptions: TabOptionModel[] = [
    new TabOptionModel(TimeInterval.quarterHour, "15 Minuten", false),
    new TabOptionModel(TimeInterval.halfHour, "30 Minuten", false),
    new TabOptionModel(TimeInterval.hour, "1 Stunde", true),
    new TabOptionModel(TimeInterval.twoHours, "2 Stunden", false)
  ]
  selectedOption: keyof SalesDto = "compositionTypeId"
  subscription: Subscription = new Subscription();
  protected readonly ErrorCodes = ErrorCodes;
  private chartElement!: ElementRef<HTMLCanvasElement>;

  constructor(
    public revenueTimelineStore: RevenueTimelineStore
  ) {
    this.subscribeToStore()
  }

  @ViewChild('timelineRevenueChart', {static: false}) set content(content: ElementRef<HTMLCanvasElement>) {
    if (content) {
      this.chartElement = content;
    }
  }

  subscribeToStore() {
    this.subscription.add(this.revenueTimelineStore.updateNotifier.subscribe(() => {

      this.drawChart()
    }))
  }

  changeOption(option: keyof SalesDto) {
    this.revenueTimelineStore.changeOption(option)
  }

  changeTimeRange(interval: TabOptionModel) {
    let intervalDuration = interval.id as TimeInterval
    this.revenueTimelineStore.changeIntervalDuration(intervalDuration)
  }

  drawChart() {
    // Define the chart to be drawn. Chartjs is used here.
    if (this.barChart != undefined) {
      this.barChart.destroy()
    }

    if (this.chartElement === undefined) {

      return;
    }

    // timelineCompositionTypeChartData


    this.barChart = new Chart(this.chartElement.nativeElement, {
      type: 'bar',

      data: this.revenueTimelineStore.getActiveDataset(),
      options: {
        interaction: {
          mode: 'index',
          intersect: false,
        },
        maintainAspectRatio: true,
        responsive: true,
        aspectRatio: 0,
        scales: {
          y: {
            beginAtZero: true,
            stacked: true,
            ticks: {
              callback: function (value: any, index: any, values: any) {
                return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(value)
              }
            }
          },
          x: {
            stacked: true
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (tooltipItem: any) => {
                let label = tooltipItem.dataset.label || '';
                return label + ": " + new Intl.NumberFormat('de-DE', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(tooltipItem.parsed.y);
              },
              // @ts-ignore
              footer: (tooltipItems: any) => {
                let sum = 0;
                let chart = tooltipItems[0].chart;
                for (let i = 0; i < chart._metasets.length; i++) {
                  if (!chart._metasets[i].visible) {
                    continue;
                  }

                  sum += tooltipItems[0].parsed._stacks.y[i]
                }
                return "Gesamt: " + new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(sum);
              }
            }
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    if (this.barChart != undefined) {
      this.barChart?.destroy()
    }
  }
}
